import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core"
import { TagCategory } from "api"
import { Ref, forwardRef } from "react"
import styled from "styled-components"
import colors from "theme/colors"
import { useCreateAiContext } from "./CreateAiContext"

const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 26px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  margin-bottom: 16px;
  text-align: right;
`

const StyledFormControlLabel = styled(FormControlLabel)<{
  $isSelected: boolean
  $isNotSelected: boolean
}>`
  width: 104px;
  height: 88px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$isSelected ? colors.black : colors.disabled)};
  display: flex;
  opacity: ${(p) => (p.$isNotSelected ? `0.5` : `1`)};
  margin-bottom: 16px;
  margin-left: 16px !important;
  .MuiTypography-root {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 160px;
    height: 135px;
    margin-left: 24px !important;
  }
`
const StyledRadioGroupContainer = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  position: relative;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`

const StyledError = styled(Typography).attrs({ variant: "body1" })`
  color: #d70202;
  font-size: 18px;
  line-height: 1;
  position: absolute;
  bottom: -8px;
  margin: 0px;
`

const StylesAi = forwardRef(
  (
    {
      styles,
      checkValiation,
    }: {
      styles: TagCategory[]
      checkValiation: boolean
    },
    stylesRef: Ref<HTMLInputElement>
  ) => {
    const { setStylesData, stylesData } = useCreateAiContext()

    return (
      <>
        <StyledTitle aria-label="בחירת סטייל לברכה - ציור">
          {styles[0]?.name}
        </StyledTitle>

        <StyledWrapper>
          <FormControl aria-label="radio-buttons-styles" component="fieldset">
            <StyledRadioGroupContainer
              aria-label="radio-buttons-styles"
              name="stylesData"
              value={stylesData || null}
              onChange={(e) => {
                setStylesData(
                  styles[0]?.tags.find((style) => style.name === e.target.value)
                    .id
                )
              }}
            >
              {styles[0]?.tags?.map((style, i) => (
                <StyledFormControlLabel
                  $isSelected={stylesData === style.id}
                  $isNotSelected={stylesData && stylesData != style.id}
                  key={i}
                  ref={i === 0 ? stylesRef : null}
                  value={style.name}
                  control={<Radio />}
                  tabIndex={0}
                  label={style.name}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault() // Prevent default behavior (form submission, etc.)
                      e.currentTarget.querySelector("input").click()
                    }
                  }}
                />
              ))}
              {!stylesData && checkValiation && (
                <StyledError>יש לבחור סטייל</StyledError>
              )}
            </StyledRadioGroupContainer>
          </FormControl>
        </StyledWrapper>
      </>
    )
  }
)

StylesAi.displayName = "StylesAi"

export default StylesAi
